export default __webpack_public_path__ + "static/media/image.rocket-science-pvt-ltd.2a63fb72.png";